import { render, staticRenderFns } from "./CopyBtn.vue?vue&type=template&id=83f5b6f6&scoped=true"
import script from "./CopyBtn.vue?vue&type=script&lang=js"
export * from "./CopyBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f5b6f6",
  null
  
)

export default component.exports